var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdviserImpactAction, AdviserImpactFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, } from "../../../../utils/questionnaireProgress";
/**
 * The Adviser Impact Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AdviserImpactQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(''), error = _a[0], setError = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    //using selector hook to fetch data from the reducer
    var _c = useSelector(function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer; }), adviserImpactData = _c.adviserImpactData, error_adviserImpact = _c.error_adviserImpact, loading = _c.loading, adviserImpactFormData = _c.adviserImpactFormData, success_adviserImpact_form = _c.success_adviserImpact_form;
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    useEffect(function () {
        questionnaireTimer.startSection("Adviser Impact");
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!adviserImpactData || adviserImpactData.length === 0) {
            dispatch(AdviserImpactAction());
        }
    }, [dispatch]);
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("Adviser Impact");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        setIsSubmitting(true);
        dispatch(AdviserImpactFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        navigate("/questionnaire/adviserFeedback");
    };
    useEffect(function () {
        if (success_adviserImpact_form && isSubmitting) {
            navigate("/questionnaire/overallExperience");
        }
    }, [success_adviserImpact_form, isSubmitting, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Adviser Impact", content: "For each of the following sections please tick the box that best represents your situation.", data: adviserImpactData, responses: adviserImpactFormData, loading: !adviserImpactData || adviserImpactData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "adviserImpact-w", width: getQuestionnaireProgressWidth("adviserImpact", getQuestionnaireAttemptVariant(quesAttemptDetails)) })] })));
}
export default AdviserImpactQuestionnaire;
